import styled from "styled-components";

const PageWrapper = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	gap: 10px;
	min-height: 100%;

	::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 64px;
		background: var(--main-explosive-opacity-05);
	}

	${(props) =>
		props.isColorful &&
		`
		::before {
			background: transparent;
		}
	`}
`;

const Page = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`;

const PageHeader = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	height: 64px;
	align-self: stretch;
	padding: 30px 4px 0px 10px;
	margin-bottom: 25px;

	a {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		z-index: 9;
	}

	svg {
		width: 50px;
		height: 50px;
	}
`;

const PageContentWrapper = styled.div`
	@media (min-width: 1280px) {
		display: flex;
		flex-direction: row;
		width: 100%;
		justify-content: space-between;
		padding: 0;
	}
`;

const PageContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 0 10px 30px;
	min-height: calc(100vh - 280px);

	@media (min-width: 1024px) {
		min-height: calc(100vh - 220px);
	}

	@media (min-width: 1280px) {
		padding: 0 20px 30px;
		position: relative;
		width: 100%;
	}
`;

const PageWithSidebar = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	max-width: 1280px;
	margin: 0 auto;
`;

const WithdrawWarning = styled.div`
	display: flex;
	width: 100%;
	color: #6e7191;
	text-align: center;
	font-size: 9px;
	font-weight: 400;
	line-height: 14px;
	letter-spacing: 0.25px;
	align-items: center;
	justify-content: center;
	padding: 10px;

	@media (min-width: 768px) {
		max-width: 624px;
		padding: 20px 0;
		margin: 0 auto;
		font-size: 12px;
		line-height: 20px;
	}

	@media (min-width: 1024px) {
		width: 100%;
		max-width: max-content;
	}

	@media (min-width: 1280px) {
		text-align: left;
		justify-content: flex-start;
		margin: 0;
		padding: 20px;
	}
`;

export {
	Page,
	PageContent,
	PageContentWrapper,
	PageHeader,
	PageWithSidebar,
	PageWrapper,
	WithdrawWarning,
};
